import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import api from '../api';
import { Mail, Lock, Eye, EyeOff, Loader2 } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_colabella-tutorials/artifacts/wcwuz41r_LOGO.png';

const LoginPage = () => {
  const { login, setUser } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handlePasswordLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { setError('Inserisci email e password'); return; }
    setLoading(true); setError('');
    try {
      const data = await api.loginPassword(email, password);
      if (data.session_token) {
        setUser(data);
        window.location.href = '/app';
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Credenziali non valide');
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src={LOGO_URL} alt="Colabella Group" className="login-logo" />
        <h1 className="login-title">Colabella Group</h1>
        <p className="login-subtitle">Gestione Cantieri</p>

        {/* Email/Password Login */}
        <form onSubmit={handlePasswordLogin} className="login-form">
          {error && <div className="login-error">{error}</div>}
          <div className="login-field">
            <Mail size={18} className="login-field-icon" />
            <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" />
          </div>
          <div className="login-field">
            <Lock size={18} className="login-field-icon" />
            <input type={showPwd ? 'text' : 'password'} placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" />
            <button type="button" className="login-pwd-toggle" onClick={() => setShowPwd(!showPwd)}>
              {showPwd ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          <button type="submit" className="login-submit" disabled={loading}>
            {loading ? <Loader2 size={18} className="spin" /> : 'Accedi'}
          </button>
        </form>

        <div className="login-divider"><span>oppure</span></div>

        {/* Google Login */}
        <button className="login-btn" onClick={login}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Accedi con Google
        </button>

        <p className="login-footer-text">Accesso riservato al personale autorizzato</p>
      </div>
    </div>
  );
};

export default LoginPage;
